import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

// material-ui
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';

// project imports
import Avatar from 'components/@extended/Avatar';
import useAuth from 'hooks/useAuth';
import { useGetMenuMaster } from 'api/menu';
import { handlerDrawerOpen } from 'api/menu';

// assets
import RightOutlined from '@ant-design/icons/RightOutlined';
import avatar1 from 'assets/images/users/avatar-1.png';


const ExpandMore = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'theme' && prop !== 'expand' && prop !== 'drawerOpen'
})(({ theme }) => ({
  transform: 'rotate(-90deg)',
  marginLeft: 'auto',
  color: theme.palette.secondary.dark,
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest
  }),
  variants: [
    { props: ({ expand }) => !expand, style: { transform: 'rotate(0deg)' } },
    { props: ({ drawerOpen }) => !drawerOpen, style: { opacity: 0, width: 50, height: 50 } }
  ]
}));

// ---- helpers (can be moved to a utils file) ----
function stripBase(pathname, base) {
  const b = String(base || '/').replace(/\/+$/, '');
  if (!b || b === '/') return pathname;
  return pathname.startsWith(b) ? pathname.slice(b.length) || '/' : pathname;
}
function currentPrefix() {
  const base = import.meta.env.VITE_APP_BASE_NAME || '/';
  const effective = stripBase(window.location.pathname, base);
  return /^\/admin(\/|$)/.test(effective) ? '/admin' : '/';
}
function join(base, path) {
  return `${String(base).replace(/\/$/, '')}/${String(path).replace(/^\//, '')}`;
}

// ==============================|| DRAWER - USER ||============================== //

export default function NavUser() {
  const navigate = useNavigate();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  const { logout, user } = useAuth();
const storedUser = (() => {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    return {};
  }
})();
const userName = storedUser?.name || user?.name || "User";
  const handleLogout = async () => {
    try {
      await logout();
      navigate(`/login`, { state: { from: '' } });
    } catch (err) {
      console.error(err);
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
   const handleClick = (event) => {
    event.stopPropagation(); // prevent bubbling to avatar/name
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  // prefix-aware profile path (change 'profile' → 'dashboard' if users don’t have a profile page)
  const prefix = currentPrefix();
  const profileHref = prefix === '/admin' ? '/admin/profile' : '/profile';
const goToProfile = () => {
  handlerDrawerOpen(false);   // SWR mutation to close sidebar
  setAnchorEl(null);          // close profile dropdown
  navigate(profileHref);      // navigate to profile
};
  return (
    <Box sx={{ p: 1.25, px: !drawerOpen ? 1.25 : 3, borderTop: '2px solid', borderTopColor: 'divider' }}>
      <List disablePadding style={{cursor:'pointer'}} onClick={goToProfile}>
        <ListItem
          disablePadding
          secondaryAction={
            <ExpandMore
              expand={open}
              drawerOpen={drawerOpen}
              id="basic-button"
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
              aria-label="show more"
            >
              <RightOutlined style={{ fontSize: '0.625rem' }} />
            </ExpandMore>
          }
          sx={{ '& .MuiListItemSecondaryAction-root': { right: !drawerOpen ? -20 : -16 } }}
        >
          <ListItemAvatar>
            <Avatar
              alt={userName}
              src={storedUser?.picture_url || user?.picture_url || avatar1}
              sx={{ ...(drawerOpen && { width: 46, height: 46 , cursor:'pointer'}) }}
              onClick={goToProfile}
            />
          </ListItemAvatar>

          <ListItemText
            primary={ <span
                style={{ cursor: 'pointer', fontWeight: 600 }}
               onClick={goToProfile}
              >
                {user?.name}
              </span>
            }
            secondary={prefix === '/admin' ? 'Admin' : `${userName}`}
          />
        </ListItem>
      </List>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{ list: { 'aria-labelledby': 'basic-button' } }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
        {/* <MenuItem component={Link} to={profileHref} onClick={handleClose}>
          Profile
        </MenuItem> */}
      </Menu>
    </Box>
  );
}
